import React, {Component} from 'react';
import {Col, Row} from 'reactstrap';
import {getData} from "../../api/doLogin";
import TodaysAppointments from "./TodaysAppointments";
import {checkPerms, RequiredPermissions} from "../../api/permissions";
import Banners from "./Banners";
import DataCard from "./DataCard";
import Messages from "./Messages/Messages";
import {formatDateLocal, formatTimeFromEpoch} from "../../util/datehelpers";
import moment from "moment";
import Incentives2 from "./Incentives/Incentives2";
import IncentivesMgr from "./Incentives/IncentivesMgr";

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

export default class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.curTaxYear = new Date().getUTCFullYear() - 1;
    this.state = {
      data: {},
      dataLoaded: true,
      intakeStatus: 0,
      uploadedDocuments: false,
      downloadDocuments: false,
      gotoIntakeUUID: "",
      calendar: [],
      cameras: [],
      calendarList: [],
      banners: [],
      leaders: [],
      incentives: [],
      gauge: {},
      mgrGauge: [],
      mgrGaugeAmount: 0,
      mgrIncentives: [],
      mbaApps: [],
      reviews: [],
      messages: [],
      defaultCalendar: this.props['loginID'] || 0,
    };
  }

  componentDidMount() {
    this.updateStats();
  }

  updateStats(cal_id = 0) {
    let self = this;
    getData(`stats${cal_id > 0 ? "?cal_id=" + cal_id : ''}`, {})
      .then((data) => {
          if (data.status === "Success") {
            // console.log(data.data);
            let curState = {...this.state};
            if (typeof data.data['calendar'] === "object") {
              curState['calendar'] = data.data.calendar;
            }
            if (typeof data.data['cameras'] === "object") {
              curState['cameras'] = data.data.cameras;
            }
            if (typeof data.data['calendarList'] === "object") {
              curState['calendarList'] = data.data.calendarList;
            }
            if (typeof data.data['banners'] === "object") {
              curState['banners'] = data.data.banners;
            }
            if (typeof data.data['leaders'] === "object") {
              curState['leaders'] = data.data.leaders;
            }
            if (typeof data.data['incentives'] === "object") {
              curState['incentives'] = data.data.incentives;
            }
            if (typeof data.data['gauge'] === "object") {
              curState['gauge'] = data.data.gauge;
            }
            if (typeof data.data['mbaApps'] === "object") {
              curState['mbaApps'] = data.data.mbaApps;
            }
            if (typeof data.data['reviews'] === "object") {
              curState['reviews'] = data.data.reviews;
            }
            if (typeof data.data['messages'] === "object") {
              curState['messages'] = data.data.messages;
            }
            if (typeof data.data['mgrGauge'] === "object") {
              curState['mgrGauge'] = data.data.mgrGauge;
              curState["mgrGaugeAmount"] = 0;
              data.data.mgrGauge.forEach((level) => {
                curState["mgrGaugeAmount"] += (level.ytd * (level.premPerc / 100)) / 1000;
              });
            }
            if (data.data['mgrIncentives']) {
              curState['mgrIncentives'] = data.data.mgrIncentives;
            }
            curState.dataLoaded = true;
            self.setState(curState);
          }
        }
      ) // JSON-string from `response.json()` call
      .catch(error => {
        console.error(error)
        //self.setState({errorMsg:error,isProcessing:false});
      });
  }

  render() {
    return (
      <div className="animated fadeIn">
        {this.state.dataLoaded && (
          <Row>

            <Col xs="12">
              <Banners banners={this.state.banners}/>
            </Col>

            <Col xs="12" lg={6}>
              {(checkPerms(this.props.perms, RequiredPermissions.CalendarSelfView)) && (
                <TodaysAppointments
                  dataSet={this.state.calendar.filter((cal) => {
                    // console.log(cal.starttime, formatTimeFromEpoch(cal.starttime));
                    let startTime = formatTimeFromEpoch(cal.starttime);
                    // let endTime = formatTimeFromEpoch(cal.endtime);
                    let startOfDay = moment(`${formatDateLocal(new Date())} 00:00:00`);
                    let endOfDay = moment(`${formatDateLocal(new Date())} 23:59:59`);
                    // console.log(startOfDay, endOfDay);
                    // console.log(startTime.valueOf());
                    // console.log(endTime.valueOf());
                    // console.log(startOfDay.valueOf());
                    // console.log(endOfDay.valueOf());
                    return startTime.valueOf() >= startOfDay.valueOf() && startTime.valueOf() <= endOfDay.valueOf();
                    // return formatTimeFromEpoch(cal.starttime).valueOf() / 1000 >= moment(`${formatDate(new Date())} 00:00:00`).unix() && forceSingleTimeZone(formatTimeFromEpoch(cal.endtime)).valueOf() / 1000 <= moment(`${formatDate(new Date())} 23:59:59`).unix()
                    // return forceSingleTimeZone(formatTimeFromEpoch(cal.starttime)).valueOf() / 1000 >= moment(`${formatDate(new Date())} 00:00:00`).unix() && forceSingleTimeZone(formatTimeFromEpoch(cal.endtime)).valueOf() / 1000 <= moment(`${formatDate(new Date())} 23:59:59`).unix()
                  })}
                  calendars={this.state.calendarList}
                  defaultCalendar={this.state.defaultCalendar}
                  onCalendarChange={(id) => this.updateStats(id)}
                  cameras={this.state.cameras}
                  onRefresh={(id) => this.updateStats(id)}/>
              )}
            </Col>

            {/*<Col xs="12" md={6}>*/}
            {/*  <Incentives leaders={this.state.leaders}*/}
            {/*              levels={this.state.incentives}*/}
            {/*              gauge={this.state.gauge}/>*/}
            {/*</Col>*/}

            <Col xs="12" md={6}>
              <Incentives2 leaders={this.state.leaders}
                           levels={this.state.incentives}
                           gauge={this.state.gauge}/>
            </Col>

            {this.state.mgrGauge && this.state.mgrGauge.length > 0 && this.state.mgrGaugeAmount > 0 && (
              <Col xs="12" md={6}>
                <IncentivesMgr leaders={this.state.mgrGauge}
                               levels={this.state.mgrIncentives}
                               gauge={this.state.mgrGaugeAmount}/>
              </Col>
            )}

            <Col xs="12" md={6}>
              <DataCard
                title={"TOP Term Production Leaders"}
                naMsg={"No Data"}
                data={this.state.mbaApps && this.state.mbaApps.map((leader) => {
                  return {
                    name: `${leader.fname} ${leader.lname}`,
                    value: leader.num
                  }
                }) || []}/>
            </Col>

            <Col xs="12" md={6}>
              <DataCard
                title={"Monthly Review Leaders"}
                naMsg={"No Data"}
                data={this.state.reviews && this.state.reviews.map((leader) => {
                  return {
                    name: `${leader.fname} ${leader.lname}`,
                    value: leader.num
                  }
                }) || []}/>
            </Col>

            <Col xs="12" md={6}>
              <Messages
                data={this.state.messages || []}/>
            </Col>

          </Row>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Dashboard.js